import apiClient from './api/client';
import { Order, CreateOrderRequest, UpdateOrderRequest, CancelOrderRequest, CreateOrderResponse } from '../types';

export const orderService = {
    getOrders: async (params?: any): Promise<{ page: number; limit: number; total: number; orders: Order[] }> => {
        const response = await apiClient.get('/orders', { params });
        return response.data;
    },

    getOrder: async (id: string): Promise<CreateOrderResponse> => {
        const response = await apiClient.get(`/orders/${id}`);
        return response.data;
    },

    createOrder: async (request: CreateOrderRequest): Promise<CreateOrderResponse> => {
        const response = await apiClient.post('/orders', request);
        return response.data;
    },

    updateOrder: async (id: string, request: UpdateOrderRequest): Promise<CreateOrderResponse> => {
        const response = await apiClient.put(`/orders/${id}`, request);
        return response.data;
    },

    cancelOrder: async (id: string, request: CancelOrderRequest): Promise<CreateOrderResponse> => {
        const response = await apiClient.post(`/orders/${id}/cancel`, request);
        return response.data;
    }
};
